import env from '@/config/env';
import * as t from '@/store/types/notificacoes';
import ACESSO_NOTIFICACAO from '@/graphql/revista/queries/AcessoInformeComercial.gql';
import ACESSO_FALANDO_DE_GENTE from '@/graphql/revista/queries/acessoFalandoDeGente.gql';
import NOTIFICACAO from '@/graphql/revista/queries/Notificacao.gql';
import NOTIFICACAO_HEADER from '@/graphql/revista/queries/NotificacaoHeader.gql';
import NOTIFICACAO_LISTA from '@/graphql/revista/queries/NotificacaoLista.gql';
import { errorGQLHandler } from '@/helpers/helpers';

export default {
  namespaced: true,
  state: {
    enabledNotify: false,
    enabledAcessoFalandoDeGente: false,
    // Button + Modal Notify
    showModal: false,
    showButton: false,
    // Modal Notify
    limit: 6,
    showComponentHeader: null,
    headerMais: false,
    dataHeader: [],
    dataHeaderFalandoDeGente: [],
    // Notify Page
    carregando: {
      header: false,
      notify: false,
      more: false,
    },
    dataPost: [],
    paginate: {
      page: 1,
      next: 1,
      showButton: false,
      per_page: 20,
    },
  },
  getters: {
    showNotify: state => state.enabledNotify,
    showFalandoDeGente: state => state.enabledAcessoFalandoDeGente,
    //
    showModal: state => state.showModal,
    showButton: state => state.showButton,
    //
    showComponentHeader: state => state.showComponentHeader,
    dataHeader: state => state.dataHeader,
    headerMais: state => state.headerMais,
    dataHeaderFalandoDeGente: state => state.dataHeaderFalandoDeGente,
    headerFalandoDeGenteMais: state => state.headerFalandoDeGenteMais,
    //
    notify: state => state.dataPost,
    carregando: state => state.carregando,
    paginateButton: state => state.paginate.showButton,
  },
  mutations: {
    [t.NOTIFY_ENABLED](state, bool) {
      state.enabledNotify = bool;
    },
    [t.NOTIFY_FALANDO_DE_GENTE](state, bool) {
      state.enabledAcessoFalandoDeGente = bool;
    },    
    [t.SHOW_MODAL](state, bool) {
      state.showModal = bool;
      state.showComponentHeader = bool ? 'Notificacoes' : null;
    },
    [t.SHOW_BUTTON](state, bool) {
      state.showButton = bool;
    },
    [t.NOTIFY_HEADER](state, payload) {
      state.dataHeader = payload;
    },
    [t.NOTIFY_HEADER_MAIS](state, bool) {
      state.headerMais = bool;
    },
    [t.NOTIFY_HEADER_FALANDO_DE_GENTE](state, payload) {
      state.dataHeaderFalandoDeGente = payload;
    },
    [t.NOTIFY_HEADER_FALANDO_DE_GENTE_MAIS](state, bool) {
      state.headerFalandoDeGenteMais = bool;
    },
    [t.NOTIFY_POST](state, payload) {
      state.dataPost = payload;
    },
    [t.NOTIFY_POST_MORE](state, payload) {
      payload.forEach(item => state.dataPost.push(item));
    },
    [t.NOTIFY_POST_PAGINATE](state, payload) {
      state.carregando.more = false;
      const total_pages = Math.ceil(payload.total / payload.per_page);
      const showButton = payload.current_page < total_pages;
      state.paginate.showButton = showButton;
      state.paginate.page = payload.current_page;
      state.paginate.next = total_pages > payload.current_page ? payload.current_page + 1 : null;
    },
    [t.NOTIFY_LOADING](state, payload) {
      const { carregando } = state;
      state.carregando = { carregando, ...payload };
    },
  },
  actions: {
    /**
     * @description Verifica se o usuário possui acesso as Notificações
     * @param commit
     * @returns {Promise<void>}
     */
    async enabledNotify({ commit }) {
      const enabled = await env.apolloRevista.query({
        query: ACESSO_NOTIFICACAO,
        variables: {},
        fetchPolicy: 'no-cache',
      });
      try {
        const {
          data: { acesso },
        } = enabled;

        commit(t.NOTIFY_ENABLED, acesso);
        return acesso;
      } catch (e) {
        console.log(e);
      }
    },
    async enabledAcessoFalandoDeGente({ commit }) {
      const enabled = await env.apolloRevista.query({
        query: ACESSO_FALANDO_DE_GENTE,
        variables: {},
        fetchPolicy: 'no-cache',
      });
      try {
        const {
          data: { acesso },
        } = enabled;
        commit(t.NOTIFY_FALANDO_DE_GENTE, acesso);
        return acesso;
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * @description Abre e fecha o modal das notificações
     * @param commit
     * @param bool
     */
    showNotificacoes({ commit }, bool) {
      if (bool) document.body.setAttribute('style', 'overflow: hidden');
      else document.body.removeAttribute('style');
      commit(t.SHOW_MODAL, bool);
    },
    /**
     * @description Verifica se o usuário possui notificações para habilitar o pulse notify
     * @param commit
     * @param rootGetters
     */
    existeNotificacao({ commit, rootGetters }) {
      const uf = rootGetters['user/uf'];
      env.apolloRevista
        .query({
          query: NOTIFICACAO,
          variables: {
            modulo: env.revista.modulo,
            canal: env.revista.canal,
            uf: [uf],
            lido: 0,
            informe: 1,
            falandoDeGente: 0
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { notify } }) => {
          const boolean = !!(notify && notify.data && notify.data.length > 0);
          commit(t.SHOW_BUTTON, boolean);
        });
    },
    existeFalandoDeGente({ commit, rootGetters }) {
      const uf = rootGetters['user/uf'];
      env.apolloRevista
        .query({
          query: NOTIFICACAO,
          variables: {
            modulo: env.revista.modulo,
            canal: env.revista.canal,
            uf: [uf],
            lido: 0,
            informe: 0,
            falandoDeGente: 1,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { notify } }) => {
          const boolean = !!(notify && notify.data && notify.data.length > 0);
          commit(t.SHOW_BUTTON, boolean);
        });
    },
    /**
     * @description Consulta os dados das ultimas 7 notificações do usuário
     * @param state
     * @param commit
     * @param rootGetters
     */
    getNotificacaoHeader({ state, commit, rootGetters }) {
      commit(t.NOTIFY_LOADING, { header: true });
      const uf = rootGetters['user/uf'];
      env.apolloRevista
        .query({
          query: NOTIFICACAO_HEADER,
          variables: {
            modulo: env.revista.modulo,
            canal: env.revista.canal,
            uf: [uf],
            lido: 0,
            informe: 1,
            falandoDeGente: 0,
            paginate: state.limit + 1,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { notify } }) => {
          const mais = notify.data.length > state.limit;
          const notifications =
            notify.data.length > state.limit ? notify.data.splice(0, state.limit) : notify.data;
          commit(t.NOTIFY_LOADING, { header: false });
          commit(t.NOTIFY_HEADER, notifications);
          commit(t.NOTIFY_HEADER_MAIS, mais);
        })
        .catch(e => errorGQLHandler(e))
        .finally(() => commit(t.NOTIFY_LOADING, { header: false }));
    },
    getNotificacaoFalandoDeGenteHeader({ state, commit, rootGetters }) {
      commit(t.NOTIFY_LOADING, { header: true });
      const uf = rootGetters['user/uf'];
      env.apolloRevista
        .query({
          query: NOTIFICACAO_HEADER,
          variables: {
            modulo: env.revista.modulo,
            canal: env.revista.canal,
            uf: [uf],
            lido: 0,
            informe: 0,
            falandoDeGente: 1,
            confirmadoFalandoDeGente: 0,
            paginate: state.limit + 1,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { notify } }) => {
          const mais = notify.data.length > state.limit;
          const notifications =
            notify.data.length > state.limit ? notify.data.splice(0, state.limit) : notify.data;
          console.log(notifications)
          commit(t.NOTIFY_LOADING, { header: false });
          commit(t.NOTIFY_HEADER_FALANDO_DE_GENTE, notifications);
          commit(t.NOTIFY_HEADER_FALANDO_DE_GENTE_MAIS, mais);
        })
        .catch(e => errorGQLHandler(e))
        .finally(() => commit(t.NOTIFY_LOADING, { header: false }));
    },
    /**
     * Busta as Notificações
     * @param state
     * @param commit
     * @param rootGetters
     * @returns {Promise<void>}
     */
    async getNotificacoes({ state, commit, rootGetters }) {
      commit(t.NOTIFY_LOADING, { notify: true });
      state.dataPost = [];
      const uf = rootGetters['user/uf'];
      const query = await env.apolloRevista.query({
        query: NOTIFICACAO_LISTA,
        variables: {
          modulo: env.revista.modulo,
          canal: env.revista.canal,
          uf: [uf],
          informe: 1,
          paginate: state.paginate.per_page,
          page: 1,
        },
      });

      try {
        const {
          data: { notify },
        } = query;
        commit(t.NOTIFY_LOADING, { notify: false });
        commit(t.NOTIFY_POST_PAGINATE, {
          current_page: notify.current_page,
          from: notify.from,
          per_page: notify.per_page,
          to: notify.to,
          total: notify.total,
        });
        commit(t.NOTIFY_POST, notify.data);
      } catch (e) {
        console.log(`Error: ${e}`);
      }
    },

    async getNotificacoesPage({ state, commit, rootGetters }) {
      const uf = rootGetters['user/uf'];
      commit(t.NOTIFY_LOADING, { more: true });
      const query = await env.apolloRevista.query({
        query: NOTIFICACAO_LISTA,
        variables: {
          modulo: env.revista.modulo,
          canal: env.revista.canal,
          uf: [uf],
          informe: 1,
          paginate: state.paginate.per_page,
          page: state.paginate.next,
        },
      });

      try {
        const {
          data: { notify },
        } = query;
        commit(t.NOTIFY_LOADING, { notify: false });
        commit(t.NOTIFY_POST_PAGINATE, {
          current_page: notify.current_page,
          from: notify.from,
          per_page: notify.per_page,
          to: notify.to,
          total: notify.total,
        });
        commit(t.NOTIFY_POST_MORE, notify.data);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
